import type { StoredMessage } from '../storage/db'

/** Kinds of messages that count as unread (not reactions/edits/notices/parties: a party, like a
 * call, shows only while it runs, so one that ended unseen mustn't leave a badge). */
export function countsAsMessage(m: StoredMessage): boolean {
  return m.envelope.type === 'text' || m.envelope.type === 'media' || m.envelope.type === 'library'
}

/** Messages from others after the last-read seq (deleted ones, and those in `skip`, don't count). */
export function unreadCount(msgs: StoredMessage[], lastRead: number, me: string | null, skip?: ReadonlySet<string>): number {
  const authorOf = new Map<string, string>()
  const deleted = new Set<string>()
  for (const m of msgs) {
    authorOf.set(m.envelope.id, m.sender.user_id)
    if (m.envelope.type === 'delete' && authorOf.get(m.envelope.target) === m.sender.user_id) deleted.add(m.envelope.target)
  }
  let n = 0
  for (const m of msgs) {
    if (m.seq > lastRead && m.sender.user_id !== me && countsAsMessage(m) && !deleted.has(m.envelope.id) && !skip?.has(m.envelope.id)) n++
  }
  return n
}

/** Merges read markers, keeping the furthest-read position per conversation. */
export function mergeMarkers(a: Record<string, number>, b: Record<string, number>): Record<string, number> {
  const out = { ...a }
  for (const [k, v] of Object.entries(b)) out[k] = Math.max(out[k] ?? 0, v)
  return out
}

export function latestSeq(msgs: StoredMessage[]): number {
  return msgs.reduce((max, m) => Math.max(max, Math.floor(m.seq)), 0)
}
